function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { Button, USPhoneNumberInput } from 'seagull';
import { usPhoneNumberValidation } from 'validators';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { StepTemplate } from "../StepTemplate";
import { Step } from "../VendorOnboardingModal.utils";
import PostalAddressForm from "../../PostalAddressForm/PostalAddressForm";
import styles from "./SecondStep.module.scss";
import { useQboInVob } from "../useQboInVob";
export function SecondStep(props) {
  var _initialState$postalA, _initialState$postalA2, _initialState$postalA3, _initialState$postalA4, _initialState$postalA5, _initialState$postalA6;

  const {
    initialState,
    onSubmit
  } = props;
  const defaultPostalAddress = {
    address1: (initialState === null || initialState === void 0 ? void 0 : (_initialState$postalA = initialState.postalAddress) === null || _initialState$postalA === void 0 ? void 0 : _initialState$postalA.address1) || '',
    address2: (initialState === null || initialState === void 0 ? void 0 : (_initialState$postalA2 = initialState.postalAddress) === null || _initialState$postalA2 === void 0 ? void 0 : _initialState$postalA2.address2) || '',
    city: (initialState === null || initialState === void 0 ? void 0 : (_initialState$postalA3 = initialState.postalAddress) === null || _initialState$postalA3 === void 0 ? void 0 : _initialState$postalA3.city) || '',
    state: (initialState === null || initialState === void 0 ? void 0 : (_initialState$postalA4 = initialState.postalAddress) === null || _initialState$postalA4 === void 0 ? void 0 : _initialState$postalA4.state) || '',
    postalCode: (initialState === null || initialState === void 0 ? void 0 : (_initialState$postalA5 = initialState.postalAddress) === null || _initialState$postalA5 === void 0 ? void 0 : _initialState$postalA5.postalCode) || '',
    country: (initialState === null || initialState === void 0 ? void 0 : (_initialState$postalA6 = initialState.postalAddress) === null || _initialState$postalA6 === void 0 ? void 0 : _initialState$postalA6.country) || 'US'
  };
  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      postalAddress: defaultPostalAddress,
      phone: (initialState === null || initialState === void 0 ? void 0 : initialState.phone) || ''
    }
  });
  const {
    showQboStep
  } = useQboInVob();
  return /*#__PURE__*/React.createElement(FormProvider, methods, /*#__PURE__*/React.createElement("form", {
    onSubmit: methods.handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(StepTemplate, {
    currentStep: Step.Second,
    stepper: "Step 2 of ".concat(showQboStep ? '3' : '2'),
    header: "What\u2019s your business address?",
    subHeader: "To ensure smooth payments, please add your business address",
    footer: /*#__PURE__*/React.createElement(Button, {
      "data-testid": "vob-step-".concat(Step.Second, "-submit"),
      type: "submit"
    }, showQboStep ? 'Continue' : 'Take me to my account')
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Controller, {
    control: methods.control,
    name: "postalAddress",
    render: _renderProps => /*#__PURE__*/React.createElement(PostalAddressForm, {
      testid: "vob"
    })
  }), /*#__PURE__*/React.createElement(Controller, {
    control: methods.control,
    name: "phone",
    rules: usPhoneNumberValidation({
      required: 'Please enter a phone number'
    }),
    render: renderProps => /*#__PURE__*/React.createElement(USPhoneNumberInput, _extends({}, connectControllerToTextField(renderProps), {
      "data-testid": "vob-phone",
      label: "Your phone number"
    }))
  })))));
}